import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import './styles/index.css'
import { App } from './App'
import { store } from './app/store'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error(
    '[RTLS] Fatal: #root element not found. Check index.html.'
  )
}

const root = createRoot(rootElement)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
)
